
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import React, { useState, useRef, useEffect } from "react";

import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import blogsData from "./BlogData";

const Template =() => {
    useEffect(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, []);
      
       
    
       useEffect(() => {
        const items = document.querySelectorAll(".faq-item h3, .faq-item .faq-toggle");
        items.forEach((faqItem) => {
          faqItem.addEventListener("click", () => {
            faqItem.parentNode.classList.toggle("faq-active");
          });
        });
    
        return () => {
          // cleanup event listeners on unmount
          items.forEach((faqItem) => {
            faqItem.replaceWith(faqItem.cloneNode(true));
          });
        };
      }, []);
    
       const techs = [
        { name: "Angular", icon: "bi-code-slash", color: "orange" },
        { name: "React", icon: "bi-lightning-charge", color: "blue" },
        { name: "AWS", icon: "bi-cloud", color: "green" },
        { name: "Docker", icon: "bi-box-seam", color: "red" },
        { name: "Azure", icon: "bi-cloud-arrow-up", color: "purple" },
        { name: "Vue", icon: "bi-diagram-3", color: "teal" },
        { name: "Python", icon: "bi-cpu", color: "yellow" },
        { name: "JavaScript", icon: "bi-braces", color: "pink" },
        { name: "Semantic", icon: "bi-layout-text-window", color: "cyan" },
        { name: "Go Lang", icon: "bi-gear", color: "orange" },
        { name: ".NET", icon: "bi-windows", color: "blue" },
        { name: "PHP", icon: "bi-file-code", color: "green" },
        { name: "NodeJs", icon: "bi-node-plus", color: "red" },
        { name: "CSS 3", icon: "bi-palette", color: "purple" },
        { name: "Bootstrap", icon: "bi-layers", color: "teal" },
        { name: "Big Data", icon: "bi-bar-chart", color: "yellow" },
        { name: "Salesforce", icon: "bi-lightbulb", color: "pink" },
        { name: "DevOps", icon: "bi-gear-wide-connected", color: "cyan" },
        { name: "Workday", icon: "bi-briefcase", color: "orange" },
      ];
    
      

    
    return (
      <div>
         <div className="index-page">
     <style>{`
        /* minimal styles for the assistant and highlight */
        .tts-highlight { background: lightblue; border-radius: 3px; }
        .assistant-button { 
          position: fixed; bottom: 30px; right: 30px; z-index: 9999;
          width: 65px; height: 65px; border-radius: 50%;
          display:flex; align-items:center; justify-content:center;
          font-size: 26px; cursor:pointer; border:none; color:#fff;
        }
        .assistant-start { background:#007bff; }
        .assistant-stop { background:#dc3545; }
      `}</style>
      <Header/>
  
  <main className="main">
    <Outlet/>

 
  </main>
 <Footer/>
</div>
        
      </div>
    )
  }
export default Template;
